import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import Collapse from 'components/Collapse/Collapse';

import { StyledList, StyledListItem } from './styles/List';

const CHANNELS_LIST = [
  { key: 'HQ1' },
  { key: 'HQ2' },
  { key: 'HQ3' },
  { key: 'HQ5' },
];

const CHANNELS_ITEMS_LIST = [
  { key: 'TYPE' },
  { key: 'CODE' },
  { key: 'DIGIT' },
  { key: 'ADDRESS' },
  { key: 'POSTCODE' },
  { key: 'AVAILABILITY' },
  { key: 'EXCEPTIONS' },
  { key: 'DISPONIBILITY' },
  { key: 'SERVICE_NAME' },
  { key: 'SERVICE_CODE' },
  { key: 'SERVICE_INFO' },
];

function SectionChannelsItems() {
  return (
    <>
      <Grid
        row
        id="channels-items"
        tag="section"
        spacingHorizontal={{
          xs: '4x',
          md: '8x',
          lg: '12x',
        }}
        spacingVertical={{
          xs: '16x',
          md: '20x',
          lg: '32x',
        }}
      >
        <Grid
          col={{ lg: 12 }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            gutterBottom={4}
            intlKey="SERVICE_CHANNELS.ITEMS.TITLE"
          />
          <StyledList>
            {CHANNELS_LIST.map(channel => (
              <StyledListItem key={channel.key}>
                <Collapse
                  buttonId={`channels-items-button-${channel.key}`}
                  contentId={`channels-items-content-${channel.key}`}
                >
                  <Collapse.Header>
                    <Typography
                      color="black"
                      colorVariant="light"
                      variant="subtitle"
                      intlKey={`SERVICE_CHANNELS.ITEMS.${channel.key}.TITLE`}
                    />
                  </Collapse.Header>
                  <Collapse.Body>
                    <Box
                      paddingTop={{ md: '8x' }}
                    >
                      {
                        CHANNELS_ITEMS_LIST.map(item => (
                          <Grid
                            key={item.key}
                            row
                            spacing="0"
                          >
                            <Grid
                              col={{ xs: 12, lg: 7 }}
                              spacingRight={{ xs: '2x', md: '4x' }}
                            >
                              <Typography
                                variant="paragraph2"
                                gutterBottom={{ xs: 0.5, md: 1.25, lg: 0 }}
                                intlKey={`SERVICE_CHANNELS.ITEMS.${item.key}`}
                              />
                            </Grid>
                            <Grid col={{ xs: 12, lg: 5 }}>
                              <Typography
                                variant="paragraph1"
                                gutterBottom={{ xs: 0.5, md: 1.25, lg: 0 }}
                                intlKey={`SERVICE_CHANNELS.ITEMS.${channel.key}.${item.key}`}
                              />
                            </Grid>
                            <Grid
                              col={{ lg: 12 }}
                            >
                              <Box
                                height="1px"
                                backgroundColor="black.defaultT10"
                                marginVertical={{ md: '8x', lg: '12x' }}
                                display={{ xs: 'none', lg: 'block' }}
                              />
                            </Grid>
                          </Grid>
                        ))
                      }
                    </Box>
                  </Collapse.Body>
                </Collapse>
              </StyledListItem>
            ))}
          </StyledList>
        </Grid>
      </Grid>
    </>
  );
}

export default React.memo(SectionChannelsItems);
